module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBoldItalic.1e93cc6a.eot";